import api from './axios';

const params = (idEmpresa) => (idEmpresa ? { id_empresa: idEmpresa } : undefined);

export const listClientes = (incluirInativos) =>
  api.get('/clientes/', { params: incluirInativos ? { incluir_inativos: true } : undefined });
export const createCliente = (data, idEmpresa) => api.post('/clientes/', data, { params: params(idEmpresa) });
export const updateCliente = (id, data, idEmpresa) =>
  api.patch(`/clientes/${id}`, data, { params: params(idEmpresa) });
